import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    title: null,
    message: null,
    message2: null,
    type: 'error',
    routeTo: null,
    timing: null,
    subtitle: null,
    button: null,
};

// Slice
const globalMessageBoxSlice = createSlice({
    name: 'globalMessageBox',

    initialState: initialState,

    reducers: {
        showGlobalMessageBox: (state, { payload }) => {
            state.title = payload.title;
            state.subtitle = payload.subtitle;
            state.message = payload.message;
            state.message2 = payload.message2;
            state.routeTo = payload.routeTo;
            state.timing = payload.timing;
            state.button = payload.button;
            if (payload.type) state.type = payload.type;
        },

        hideGlobalMessageBox: () => {
            return initialState;
        },
    },
});

// Actions
export const { showGlobalMessageBox, hideGlobalMessageBox } =
    globalMessageBoxSlice.actions;

// Selector
export const globalMessageBoxSelector = (state) => state.globalMessageBox;

// Reducer
export const globalMessageBoxReducer = globalMessageBoxSlice.reducer;
